import React from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
import { DollarSign, TrendingUp, Shield, Star, Check } from 'lucide-react';
export function Slide8_Investment() {
  const buildPoints = ['Company and opportunity profiling', 'Custom ATS, dashboards, and job board integrations', 'Culture video and ad copywriting', 'Landing pages and application flows', 'End-to-end funnel, from ad to onboarding', 'Regional comp and role benchmarking', 'Pre-launch system stress test', 'Team training and 90-day coaching to optimize output'];
  const systemPoints = ['Active ad campaign management and real-time optimization', 'Live applicant screening, 14 hrs/day, 7 days/week', 'Data-driven candidate scoring and handoff', 'Two-day live sales school for every new hire', 'Monthly executive recruiting review', 'Ongoing consulting and campaign performance enhancement'];
  const performancePoints = ['Per rep bonuses', 'Tied to retention milestones, not just placement', 'We only win when your reps stick'];
  return <SlideLayout data-id="element-344">
      <div className="flex flex-col h-full justify-center space-y-8 sm:space-y-10" data-id="element-345">
        <div className="space-y-4 text-center" data-id="element-346">
          <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-347">
            Partnership Structure
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-348">
            Pricing reflects ownership and accountability, not effort or hours.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto w-full" data-id="element-349">
          {/* Build */}
          <motion.div className="flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-350">
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-6 flex-1" data-id="element-351">
              <div className="w-11 h-11 rounded-full bg-slate-800 flex items-center justify-center mb-4 border border-slate-700" data-id="element-352">
                <Shield className="w-5 h-5 text-[#7FE0C3]" data-id="element-353" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-354">
                Build and Implementation
              </h3>
              <p className="text-slate-400 text-xs mb-5" data-id="element-355">One-time setup</p>
              <ul className="space-y-2.5" data-id="element-356">
                {buildPoints.map((point, i) => <li key={i} className="flex items-start" data-id="element-357">
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2.5 mt-0.5 shrink-0" data-id="element-358" />
                    <span className="text-slate-300 text-sm leading-snug" data-id="element-359">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* System */}
          <motion.div className="flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} data-id="element-360">
            <div className="bg-slate-900/40 border border-[#7FE0C3]/30 rounded-xl p-6 relative flex-1" data-id="element-361">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-362" />
              <div className="w-11 h-11 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mb-4 border border-[#7FE0C3]/20" data-id="element-363">
                <DollarSign className="w-5 h-5 text-[#7FE0C3]" data-id="element-364" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-365">System</h3>
              <p className="text-[#7FE0C3] text-xs mb-5" data-id="element-366">Monthly recurring</p>
              <ul className="space-y-2.5 mb-5" data-id="element-367">
                {systemPoints.map((point, i) => <li key={i} className="flex items-start" data-id="element-368">
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2.5 mt-0.5 shrink-0" data-id="element-369" />
                    <span className="text-slate-300 text-sm leading-snug" data-id="element-370">
                      {point}
                    </span>
                  </li>)}
              </ul>
              <div className="flex items-center justify-center px-4 py-2.5 rounded-full bg-amber-500/10 border border-amber-500/30" data-id="element-371">
                <Star className="w-4 h-4 text-amber-400 mr-2 shrink-0" fill="currentColor" data-id="element-372" />
                <span className="text-amber-400 font-medium text-sm" data-id="element-373">
                  Month-to-Month Agreement
                </span>
              </div>
            </div>
          </motion.div>

          {/* Performance */}
          <motion.div className="flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} data-id="element-374">
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-6 flex-1" data-id="element-375">
              <div className="w-11 h-11 rounded-full bg-slate-800 flex items-center justify-center mb-4 border border-slate-700" data-id="element-376">
                <TrendingUp className="w-5 h-5 text-amber-400" data-id="element-377" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-378">Performance</h3>
              <p className="text-slate-400 text-xs mb-5" data-id="element-379">Success-based</p>
              <ul className="space-y-2.5" data-id="element-380">
                {performancePoints.map((point, i) => <li key={i} className="flex items-start" data-id="element-381">
                    <Check className="w-4 h-4 text-amber-400 mr-2.5 mt-0.5 shrink-0" data-id="element-382" />
                    <span className="text-slate-300 text-sm leading-snug" data-id="element-383">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>

        <div className="p-5 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-384">
          <p className="text-[#7FE0C3] text-center font-medium" data-id="element-385">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </div>
    </SlideLayout>;
}